import type { AdjustmentKind } from "../../core/document/Layer";

interface AdjustmentItem {
  kind: AdjustmentKind;
  label: string;
  icon: string;
}

const ADJUSTMENT_ITEMS: AdjustmentItem[] = [
  { kind: "brightness-contrast", label: "Brightness/Contrast", icon: "☀" },
  { kind: "levels", label: "Levels", icon: "📊" },
  { kind: "curves", label: "Curves", icon: "〰" },
  { kind: "exposure", label: "Exposure", icon: "📷" },
  { kind: "vibrance", label: "Vibrance", icon: "🎨" },
  { kind: "hue-saturation", label: "Hue/Saturation", icon: "🌈" },
  { kind: "color-balance", label: "Color Balance", icon: "⚖" },
  { kind: "black-white", label: "Black & White", icon: "◐" },
  { kind: "photo-filter", label: "Photo Filter", icon: "🔲" },
  { kind: "channel-mixer", label: "Channel Mixer", icon: "🔀" },
  { kind: "color-lookup", label: "Color Lookup", icon: "🔍" },
  { kind: "invert", label: "Invert", icon: "🔄" },
  { kind: "posterize", label: "Posterize", icon: "▥" },
  { kind: "threshold", label: "Threshold", icon: "▨" },
  { kind: "gradient-map", label: "Gradient Map", icon: "🗺" },
  { kind: "selective-color", label: "Selective Color", icon: "🎯" },
];

export class AdjustmentsPanel {
  private container: HTMLElement;
  private gridEl: HTMLElement;
  private onCreate: ((kind: AdjustmentKind) => void) | null = null;

  constructor() {
    this.container = document.createElement("div");
    this.container.className = "adjustments-panel";
    this.container.innerHTML = `
      <div class="panel-title">Adjustments</div>
      <div class="adjustments-grid" id="adjustments-grid"></div>
    `;
    this.gridEl = this.container.querySelector(".adjustments-grid")!;
    this._render();
  }

  setCallback(onCreate: (kind: AdjustmentKind) => void): void {
    this.onCreate = onCreate;
  }

  private _render(): void {
    this.gridEl.innerHTML = ADJUSTMENT_ITEMS.map(item => `
      <button class="adjustment-item" data-kind="${item.kind}" title="${item.label}">
        <span class="adjustment-item__icon">${item.icon}</span>
        <span class="adjustment-item__label">${item.label}</span>
      </button>
    `).join("");

    this.gridEl.querySelectorAll(".adjustment-item").forEach(el => {
      el.addEventListener("click", () => {
        const kind = (el as HTMLElement).dataset.kind as AdjustmentKind;
        if (this.onCreate) this.onCreate(kind);
      });
    });
  }

  mount(parent: HTMLElement): void {
    parent.appendChild(this.container);
  }

  destroy(): void {
    this.container.remove();
  }
}
